import simpleParallax from 'simple-parallax-js';

const image = document.getElementsByClassName('js-parallax');
new simpleParallax(image, {
  //orientation: 'right'
  scale: 1.25
});
